export var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/apollo-cache/lib/types/Cache.js
// module id = 296
// module chunks = 0